import {Placeholder} from '@logistics-frontend/core/i18n/types'
import {CountryCode} from '@logistics-frontend/core/types'

import {StrictTranslator} from './Disclaimer.types'

const local =
  (...args: string[]) =>
  (key: string) =>
    [key, ...args].filter(Boolean).join('.')

export const localizedVariants =
  <T extends Placeholder>(t: StrictTranslator, country: CountryCode, zone: string, tariff: string) =>
  (key: string, placeholder?: T) =>
    [
      t(local(country, zone, tariff)(key), placeholder),
      t(local(zone, tariff)(key), placeholder),
      t(local(country, zone)(key), placeholder),
      t(local(country, tariff)(key), placeholder),
      t(local(country)(key), placeholder),
      t(key, placeholder),
    ].find(localized => !!localized) || ''
